{
    const FILE_DOWNLOAD_SELECTOR = ".bux-file-download";
    const POINTER_MOVE_THRESHOLD = 8;

    const addFileDownloadClickHandling = (container: HTMLElement) => {
        const link = container.querySelector("a");
        if (!link) return;

        container.style.cursor = "pointer";

        link.addEventListener("click", (event) => event.stopPropagation());
        link.addEventListener("pointerdown", (event) => event.stopPropagation());

        let startX = 0;
        let startY = 0;

        container.addEventListener("pointerdown", (event) => {
            if (event.button !== 0) return;

            startX = event.clientX;
            startY = event.clientY;
        });

        container.addEventListener("pointerup", (event) => {
            if (event.button !== 0) return;

            const diffX = Math.abs(event.clientX - startX);
            const diffY = Math.abs(event.clientY - startY);

            if (diffX < POINTER_MOVE_THRESHOLD && diffY < POINTER_MOVE_THRESHOLD) {
                event.preventDefault();
                link.click();
            }
        });
    };

    const downloadCards = document.querySelectorAll(FILE_DOWNLOAD_SELECTOR) as NodeListOf<HTMLElement>;
    for (const element of downloadCards) { addFileDownloadClickHandling(element); }
}
